import { Bus, Cancellations, ChangeFlight, Expressway, Flights, HomeIcon, Hotels, Offers ,
    ProfileMini,
    SettingsMini,
    ShortcutsMini,
    Support,
    Ticket,
    TravellersMini,
    Trips,
    TripsMini,
    WalletMini,
    Work
} from '@/assets/icons'

export const LOGIN_BANNER_URL =
    'https://rukmini-ct.flixcart.com/f_auto,q_auto,w_410,h_437,dpr_2/offermgmt-prod/offermgmt/bbdJson/Desktop_Banner.png'
export const accoutOptions = [
    {
        text: 'Trips',
        link: '/accounts/trips',
        icon: TripsMini,
        actionName: 'your_trips_trips'
    },
    {
        text: 'Shortlists',
        link: '/account/shortlists',
        icon: ShortcutsMini,
        actionName: 'your_trips_shortlists'
    },
    {
        text: 'Travellers',
        link: '/account/travellers',
        icon: TravellersMini,
        actionName: 'your_trips_travellers'
    },
    {
        text: 'Cleartrip Wallet',
        link: '/accounts/wallet',
        icon: WalletMini,
        actionName: 'your_trips_wallet'
    },
    {
        text: 'Expressway',
        link: '/accounts/expressway',
        icon: Expressway,
        actionName: 'your_trips_expressway'
    },
    {
        text: 'Profile',
        link: '/accounts/profile',
        icon: ProfileMini,
        actionName: 'your_trips_profile'
    },
    {
        text: 'Settings',
        link: '/account/settings',
        icon: SettingsMini,
        actionName: ''
    }
]
export const tools = [
    {
        text: 'Cancellations',
        link: '/accounts/trips',
        icon: Cancellations,
        actionName: 'your_trips_cancellations'
    },
    {
        text: 'Change flight',
        link: '/accounts/trips',
        icon: ChangeFlight,
        actionName: 'your_trips_change_flights'
    },
    {
        text: 'Print ticket',
        link: '/accounts/trips',
        icon: Ticket,
        actionName: 'your_trips_print_ticket'
    },
    {
        text: 'Print flight voucher',
        link: '/vouchers',
        icon: Ticket,
        actionName: 'your_trips_flight_voucher'
    }
]
export const errorConfig = {
    ERROR_IN_SENDING_SMS: 'Failed to send SMS OTP. Please try again.',
    OTP_SEND_LIMIT_EXCEEDED: 'You exceeded the OTP limit. Please try again after 10 minutes.',
    ERROR_IN_SENDING_EMAIL: 'Failed to send email OTP. Please try again.',
    NO_SAVED_OTP_FOUND: 'OTP expired. Please resend OTP and try again.',
    INVALID_OTP: 'Please enter a valid OTP',
    OTP_VALIDATE_LIMIT_EXCEEDED: 'You exceeded the OTP validation limit. Please try again in 10 minutes.',
    INVALID_MOBILE: 'Something went wrong. Please try again.',
    DEFAULT: 'Something went wrong. Please try again.'
}

export const OTP_ERRORS = Object.keys(errorConfig)

export const MOBILE_COUNTRY_CODES = [{ name: 'India', code: '91', min: 10, max: 10 }]
export const HAMBURGER_OPTIONS = [
    {
        icon: HomeIcon,
        text: 'Home',
        link: '/',
        isSelected: false
    },
    {
        icon: Flights,
        text: 'Flights',
        link: '/flights',

        isSelected: true
    },
    {
        icon: Hotels,
        text: 'Hotels',
        link: '/hotels'
    },
    {
        icon: Bus,
        text: 'Bus',
        link: '/bus',
        isSelected: false
    },
    {
        icon: Offers,
        text: 'Offers',
        link: '/all-offers/?categories=flights'
    },
    {
        icon: Trips,
        text: 'My trips',
        link: '/account/trips'
    },
    {
        icon: Work,
        text: 'Cleartrip for Work',
        link: 'https://business.cleartrip.com/'
    },
    {
        icon: Support,
        text: 'Support',
        link: '/support'
    }
]

export const loginBannerImages = [
    {
        url: 'https://rukmini-ct.flixcart.com/f_auto,q_auto,w_350,h_287,dpr_2/offermgmt-prod/offermgmt/images/banner/ct_hotel_pricing_icon_desktop.png',
        backgroundColor: '#FF8057',
    },
    {
        url: 'https://rukmini-ct.flixcart.com/f_auto,q_auto,w_350,h_287,dpr_2/offermgmt-prod/offermgmt/images/banner/ct_flight_pricing_icon_desktop.png',
        backgroundColor: '#FFD468',
    },
    {
        url: 'https://rukmini-ct.flixcart.com/f_auto,q_auto,w_350,h_287,dpr_2/offermgmt-prod/offermgmt/images/banner/ct_cfw_icon_desktop.png',
        backgroundColor: '#5295FF',
    },
    {
        url: 'https://rukmini-ct.flixcart.com/f_auto,q_auto,w_350,h_287,dpr_2/offermgmt-prod/offermgmt/images/banner/uhp_d_login_slideThreeAir.png',
        backgroundColor: '#54BB52',
    },
    {
        url: 'https://rukmini-ct.flixcart.com/f_auto,q_auto,w_350,h_287,dpr_2/offermgmt-prod/offermgmt/images/banner/uhp_d_login_slideFourHotels.png',
        backgroundColor: '#FF8862',
    },
    {
        url: 'https://rukmini-ct.flixcart.com/f_auto,q_auto,w_350,h_287,dpr_2/offermgmt-prod/offermgmt/images/banner/ct_supercoins_discount_icon_desktop.png',
        backgroundColor: '#A06AE5',
    },
];

export const loginBannerImagesBeforeEvent = [
  {
    url: 'https://rukmini-ct.flixcart.com/f_auto,q_auto,w_410,h_337,dpr_2/offermgmt-prod/offermgmt/images/banner/novac-april-26-desktop-date-1.png',
    backgroundColor: '#EE5528'
  },
  {
    url: 'https://rukmini-ct.flixcart.com/f_auto,q_auto,w_410,h_337,dpr_2/offermgmt-prod/offermgmt/images/banner/novac-april-26-desktop-date-2.png',
    backgroundColor: '#1769EC',
  },
]

export const loginBannerImagesDuringEvent = [
  {
    url: `https://rukmini-ct.flixcart.com/f_auto,q_auto/offermgmt-prod/offermgmt/images/banner/BBD_FHP_DT1.png`,
    backgroundColor: '#3D1A6E',
  },
  {
    url: `https://rukmini-ct.flixcart.com/f_auto,q_auto/offermgmt-prod/offermgmt/images/banner/BBD_FHP_DTR1.png`,
    backgroundColor: '#F4C6D7',
  },
]

export const bbdLogoStart = "https://rukmini-ct.flixcart.com/f_auto,q_auto/offermgmt-prod/offermgmt/images/banner/BBD_2025_LOGOstarts_22nd_sept.png"
export const bbdLogoEnd = "https://rukmini-ct.flixcart.com/f_auto,q_auto/offermgmt-prod/offermgmt/images/banner/BBD_2025_LOGOstarts_22nd_to_2ndOct-1.png"
const blackFridaySaleLogoPos = { top: '6px', right: '24px' }

export const SaleConfigObject = {
   BlackFridaySale: {
    logos: [
      { from: '2026-09-28T00:00:00', to: '2026-10-07T23:59:59', url: 'https://rukmini-ct.flixcart.com/f_auto,q_auto,dpr_3/offermgmt-prod/offermgmt/images/banner/SALE_2x1.png' },
      { from: '2026-10-08T00:00:00', to: '2026-10-16T23:59:59', url: 'https://rukmini-ct.flixcart.com/f_auto,q_auto,dpr_3/offermgmt-prod/offermgmt/images/banner/SALE_2x2.png' },
      { from: '2026-10-17T00:00:00', to: '2026-10-17T23:59:59', url: 'https://rukmini-ct.flixcart.com/f_auto,q_auto,dpr_3/offermgmt-prod/offermgmt/images/banner/SALE_2x4.png' },
      { from: '2026-10-18T00:00:00', to: '2026-10-18T23:59:59', url: 'https://rukmini-ct.flixcart.com/f_auto,q_auto,dpr_3/offermgmt-prod/offermgmt/images/banner/SALE_2x3.png' },
    ],
    logoMetrics: { logoHeight: '80px', logoWidth: '75px', cusomStyle: blackFridaySaleLogoPos },
    bannerBackground: 'linear-gradient(270deg, #481386 6.4%, rgba(169, 11, 255, 0) 74.75%)',
    backgroundColor: '#481386',
    header: 'Biggest discounts on Flights',
    subHeader: 'Up to 35% off | Flights starting ₹1,499 | Free Visa Rejection Cover ',
  }
}
export const loginHelpText =
    'We no more support email based login. You can now login via mobile number & link email to access your account.'
                                
export const enum HOME_PAGE_COMPONENTS_NAME {
    SEARCH_FIELD = 'searchField',
    SEARCH_BUTTON = 'searchButton',
    TOP_DESTINATION = 'popularDestination',
    TOP_flightS = 'topflights',
    TRENDING_GATEWAYS = 'trendingGateways',
    BSB_BANNER = 'bsbBanner',
    AUTO_SUGGEST_OPTION = 'autoSuggestOption',
    LOGIN_BUTTON = 'loginButton',
    PAX_OPTION = 'paxOption',
    PAX_ADD_MORE = 'paxAddMoreRoom',
    PAX_SHOW_OPTION = 'paxShowOption',
    PAX_ADD_ANOTHER_ROOM = 'paxAddAnotherRoom',
    PAX_BUTTON = 'paxButton',
    PAX_COUNTER = 'paxCounter',
    PAX_REMOVE_ROOM = 'paxRemoveRoom',
    PAX_PERSON_COUNT = 'paxPersonCount',
    CALENDAR = 'calendar',
    MY_ACCOUNT = 'myAccount'
}

export const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
        {
            '@type': 'Question',
            name: 'What services does Cleartrip offer?',
            acceptedAnswer: {
                '@type': 'Answer',
                text: 'Cleartrip is dedicated to making travel easy, economical, and uncomplicated, from international to domestic flights, from early morning to late night flights, and from budget to luxury flights. Cleartrip allows you to book your flight with just a few clicks. Our features include:\n1. ClearChoice Max offers free cancellation or rescheduling for domestic and international flights.\n2. ClearChoice Plus: Free date or airline change up to 12 hours before departure.\n3. Medical reasons to cancel your domestic travel, and receive up to INR3500 compensation against airline cancellation charges per person per segment.',
            },
        },
        {
            '@type': 'Question',
            name: 'How do I create an account on Cleartrip?',
            acceptedAnswer: {
                '@type': 'Answer',
                text: "For all your travel bookings, sign up on Cleartrip. \n1. Go to the home page, click the link (top right), and enter your email address. We'll then send you an account activation link.\n2. Click it, and you'll be able to access your Cleartrip account.\nThe account activation link expires three days after you provide us with your email address, so please activate your account within that time frame.",
            },
        },
        {
            '@type': 'Question',
            name: 'How can I contact Cleartrip customer support?',
            acceptedAnswer: {
                '@type': 'Answer',
                text: 'You can reach Cleartrip Customer Support and Phone Number. Contact us at +91 9595333333. We are here to assist you with your booking and rescheduling queries.',
            },
        },
        {
            '@type': 'Question',
            name: 'How do I search for flights on Cleartrip?',
            acceptedAnswer: {
                '@type': 'Answer',
                text: "We make it relatively simple to search and book Cleartrip flights\n1. Enter source and destination cities/airports.\n2. Select the date of travel.\n3. Select the number of travellers.\n4. Hit enter, and you're done! You have a search list of all available flights, sorted by price.",
            },
        },
        {
            '@type': 'Question',
            name: 'How do I search for hotels on Cleartrip?',
            acceptedAnswer: {
                '@type': 'Answer',
                text: "Booking a hotel online has never been easier than it is with Cleartrip.\n1. Click the 'hotels' tab on the site.\n2. Enter the city/locality/landmark/hotel name in the search bar.\n3. Enter the check-in and check-out dates.\n4. Choose the number of travellers and press enter.\nYou may also refine your hotel booking search results by utilising parameters such as price, star rating, traveller rating, facilities, and preferences such as hill-view or couple-friendly hotels. Cleartrip offers hotels for all types of stays. Cleartrip hotels are curated to give you the best value for your money.",
            },
        },
        {
            '@type': 'Question',
            name: 'How do I book train tickets on Cleartrip?',
            acceptedAnswer: {
                '@type': 'Answer',
                text: "Cleartrip enables you to buy train tickets and search for them. Simply click 'check availability' on the search results page, and you will find the book button to click for bookings. Booking Cleartrip trains is simple and fast.",
            },
        },
    ],
};

export const flightFaqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
        {
            "@type": "Question",
            "name": "What are the advantages of online flight booking?",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "Through online air ticket booking, you can compare airfare across multiple airlines and choose flights that suit your budget and travel plans. You also get access to secure payment options, instant confirmation, and exclusive flight booking offers."
            }
        },
        {
            "@type": "Question",
            "name": "How can I book flight tickets online?",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "With Cleartrip, you can easily search and book domestic and international air tickets online. Simply enter your travel details (destination, travel dates, passenger details), select your preferred flight, and complete your flight ticket booking in a few easy steps."
            }
        },
        {
            "@type": "Question",
            "name": "Why should I make a flight booking on Cleartrip?",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "Cleartrip offers a simple flight booking experience, competitive airfare, multiple payment options, and exclusive flight ticket offers. You can compare flight tickets across leading airlines and book with confidence."
            }
        },
        {
            "@type": "Question",
            "name": "How can I get cheap flight tickets?",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "To find cheap flights, compare travel dates, book early, and explore available flight offers and discounts. Flexible travel plans can often help you secure lower airfare."
            }
        },
        {
            "@type": "Question",
            "name": "When should I book to get the best flight ticket prices?",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "For domestic flight tickets, it is recommended to book 3 to 6 weeks in advance. For international air tickets, booking 6 to 10 weeks before departure can help you get better airfare."
            }
        },
        {
            "@type": "Question",
            "name": "How can I get discounts and offers on flight tickets?",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "You can save on flight ticket bookings through bank offers, coupon codes (CTDOM for domestic flight bookings and CTINT for international flight bookings), and promotional campaigns like the Travel Max Sale and Big Travel Sale. Checking available offers before payment can help reduce your flight ticket price."
            }
        },
        {
            "@type": "Question",
            "name": "What factors should I compare before booking a flight ticket?",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "Before booking a flight ticket, compare airfare, baggage allowance, flight duration, layovers, departure timings and travel class (Economy, Premium Economy, Business, and First Class). This helps you choose the most suitable flight for your journey."
            }
        },
        {
            "@type": "Question",
            "name": "How do I check if my flight ticket is confirmed?",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "After completing your flight booking and successful payment, you will receive an instant confirmation email and SMS with your e-ticket and flight reservation details. You can also view your booking on the Cleartrip app."
            }
        }
    ]
};